export const DIMENSION_ORIGIN = {
  NPS: 0,
  person: 1,
  form: 2
}
